"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnnxInferenceService = void 0;
var logging_1 = require("@augloop/logging/dist/src/client/logging");
var model_1 = require("./model");
var OnnxInferenceService = /** @class */ (function () {
    function OnnxInferenceService() {
    }
    OnnxInferenceService.create = function (appName, version) {
        var _this = this;
        // Start log operation
        var createInferenceServiceOp = new logging_1.Operation({
            operationName: 'CreateOnnxInferenceService',
            success: true,
            resultDescription: ''
        });
        createInferenceServiceOp.start();
        var endLogWithError = function (error) {
            createInferenceServiceOp.resultDescription = error.message;
            logging_1.Log.info(0x2079e5cc /* tag_644xm */, logging_1.LogCategory.CoreDefault, createInferenceServiceOp.stop());
        };
        if (model_1.lackingPromiseOrWasmSupport(createInferenceServiceOp)) {
            return Promise.reject(new Error('Browser lacking necessary support for inference service'));
        }
        if (!appName || !version) {
            var error = new Error("Error: appName and/or version not provided");
            endLogWithError(error);
            return Promise.reject(error);
        }
        return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.src = _this.createCdnUrl(appName, version);
            script.onload = function () {
                var _a;
                if (((_a = window) === null || _a === void 0 ? void 0 : _a.ort) && window.ort.InferenceSession && window.ort.Tensor) {
                    resolve(undefined);
                }
                else {
                    reject(new Error('Tensor and/or InferenceSession are undefined'));
                }
            };
            script.onerror = reject;
            document.body.appendChild(script);
        }).then(function () {
            createInferenceServiceOp.resultDescription = 'Success creating inference service';
            logging_1.Log.info(0x2079e5cd /* tag_644xn */, logging_1.LogCategory.CoreDefault, createInferenceServiceOp.stop());
            return new OnnxInferenceService();
        }).catch(function (error) {
            endLogWithError(error);
            throw error;
        });
    };
    OnnxInferenceService.createCdnUrl = function (appName, version) {
        // TODO add correct logic
        var cdnUrl = "https://" + appName + version;
        return cdnUrl;
    };
    OnnxInferenceService.prototype.createModel = function (modelUrl) {
        return model_1.Model.create(modelUrl);
    };
    OnnxInferenceService.prototype.createInputs = function () {
        return model_1.Inputs.create();
    };
    return OnnxInferenceService;
}());
exports.OnnxInferenceService = OnnxInferenceService;
//# sourceMappingURL=onnxInferenceService.js.map